export default "__VITE_ASSET__CJQpjLaw__"